import { useMemo } from 'react';

import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { ENABLE_AMENDMENT_AI_SLIDE_OUT } from '#client/constants/experimentsFlags';

/**
 * Hook to retrieve the feature flag values for the velo banner
 * @returns {object} An object with the feature flag value for the velo banner
 */
export function useVeloBannerFeatureFlag() {
  const enableAmendmentAiSlideOut = useExperimentFlag(ENABLE_AMENDMENT_AI_SLIDE_OUT, false);

  return useMemo(() => enableAmendmentAiSlideOut, [enableAmendmentAiSlideOut]);
}
